export default function auth(to, from, next) {
  const token = localStorage.getItem("token");
  if (!token) {
    console.warn("No token found, redirecting to login...");
    return next("/login");
  }
  next(); 
}